import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const ACTOR_COLORS = {
  "onb":              "#176736",
  "dreal":            "#0e4596",
  "edf":              "#ffcf31",
  "consumers":        "#c72f30",
  "elus-locaux":      "#205673",
  "agriculture":      "#ff5b2d",
  "petit-commerce":   "#f85ca5",
  "grosse-industrie": "#65326b",
  "industry":         "#65326b",
  "agence-eau":       "#736e6a",
};

const Header = ({
  budget,
  waterBudget,
  round,
  popularity,
  shortTermNeeds,
  initialShortTermNeeds,
  language,
  actorsBudgets,
  nbRounds = 5,
}) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const startYear = new Date(new Date().setMonth(new Date().getMonth() + 2)).getFullYear();

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  const hasActors = actorsBudgets && actorsBudgets.length > 0;

return (
  <header className="App-header">
    <div className="logo-container" onClick={() => {navigate('/')}}>
      <img src="/hydros_full_logo.png" className="App-logo" alt="logo" />
      <div className="logo-text">{t("compte-gouttes-name")}</div>
    </div>

    {round != null && round < nbRounds && (
      <div className="round">
        {t("Tour")} n°{round + 1} - {startYear + round}
        {initialShortTermNeeds > 0 && (
          <img src="/warning.png" className="warning-image" />
        )}
      </div>
    )}

    <div className="budgets color-sand">
      {budget != null && round < nbRounds && (
        <div
          className={`budget-tooltip-wrapper${hasActors ? " budget-tooltip-wrapper--active" : ""}`}
          onMouseEnter={() => hasActors && setTooltipVisible(true)}
          onMouseLeave={() => setTooltipVisible(false)}
        >
          <p className="budget">
            {budget}
            <img className="budget-currency" src="/vote-sand4.png" />
          </p>

          {hasActors && tooltipVisible && (
            <div className="budget-tooltip">
              <p className="budget-tooltip-title">{t("Répartition des voix")}</p>
              <ul className="budget-tooltip-list">
                {actorsBudgets.map((actor) => {
                  const color = ACTOR_COLORS[actor.actor_id] || "#205673";
                  return (
                    <li key={actor.actor_id} className="budget-tooltip-item">
                      <span className="budget-tooltip-dot" style={{ backgroundColor: color }} />
                      <span className="budget-tooltip-name">{actor.name}</span>
                      <span className="budget-tooltip-votes">{actor.budget}</span>
                      <img className="budget-tooltip-icon" src="/vote-sand4.png" alt="vote" />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      )}

      {waterBudget != null && (
        <div className="water-budget-container">
          <div className="gauge-container">
            <div
              className="gauge-content"
              style={{
                width:
                  String(100 - waterBudget > 100 ? 100 : 100 - waterBudget) +
                  "%",
              }}
            ></div>
          </div>
          {initialShortTermNeeds > 0 && (
            <p className="water-budget color-sand">
              {shortTermNeeds > 0 ? shortTermNeeds : 0}
              <img
                className="water-budget-drop"
                src="/hydros_logo.png"
                alt="water drop"
              />
            </p>
          )}
        </div>
      )}
    </div>
  </header>
)};

export default Header;
